import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_LINK =
    "https://wa.me/60183628663?text=" +
    encodeURIComponent(
        "Hi Kaily, I'd like to know more about your shoot services for my F&B business."
    );

/* 2026-02 — smaller FAB per Kaily's brief. The old 56×56 button sat
   on top of hero CTAs on 360-390 px screens and the heavy olive fill
   fought the editorial palette. New sizing: 44×44 on mobile, 48×48 on
   md+, nudged further into the corner (bottom-5 right-5), and a quieter
   border-only treatment on cream — still clearly tappable and above the
   WCAG 44 px minimum target. */
export default function WhatsAppFab() {
    return (
        <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-40 h-11 w-11 md:h-12 md:w-12 rounded-full bg-cafe-cream text-cafe-olive border border-cafe-olive/40 flex items-center justify-center shadow-[0_6px_20px_-8px_rgba(44,30,22,0.4)] hover:bg-cafe-olive hover:text-cafe-cream hover:-translate-y-0.5 transition-all"
        >
            <MessageCircle className="h-4 w-4 md:h-5 md:w-5" strokeWidth={1.75} />
        </a>
    );
}
